<script setup lang="ts">
  import { FlagEnum } from '@/types/generated'
  import { useFeatureFlag } from '@/composables/useFeatureFlag'
  import ClientPortalBase from './ClientPortalBase.vue'
  import ClientPortalView from '@/views/ClientPortalView.vue'
  import QuestionnairePreviewView from '@/views/QuestionnairePreviewView.vue'
  import QuestionnaireExternalView from '@/views/QuestionnaireExternalView.vue'
  import { onMounted, ref, computed } from 'vue'
  import { useRoute } from 'vue-router'
  import { LoaderCircle } from 'lucide-vue-next'

  const route = useRoute()
  const { isEnabled, isLoading, checkFlag } = useFeatureFlag(FlagEnum.CLIENT_PORTAL_V3_API)
  const flagChecked = ref(false)

  const isPreviewRoute = computed(() => {
    return route.path.includes('/questionnaires/preview/')
  })

  const isExternalQuestionnaireRoute = computed(() => {
    return route.path.includes('/external/questionnaires/')
  })

  const isExternalPdfRoute = computed(() => {
    return (
      route.path.includes('/external/pdf-templates/') || route.path.includes('/external/document/')
    )
  })

  const isPdfFormSubmissionRoute = computed(() => {
    return route.path.includes('/pdf-form-submissions/')
  })

  const isCompletedRoute = computed(() => {
    return (
      route.path.includes('/external/questionnaire/completed') ||
      route.path.includes('/external/pdf/completed')
    )
  })

  onMounted(async () => {
    if (isExternalPdfRoute.value || isCompletedRoute.value || isPdfFormSubmissionRoute.value) {
      flagChecked.value = true
      return
    }

    await checkFlag()
    flagChecked.value = true
  })
</script>

<template>
  <div>
    <div
      v-if="isLoading || !flagChecked"
      class="flex h-screen items-center justify-center"
    >
      <LoaderCircle
        :size="100"
        class="animate-spin"
      />
    </div>
    <QuestionnairePreviewView v-else-if="isPreviewRoute && !isEnabled" />
    <ClientPortalView
      v-else-if="
        !isPreviewRoute &&
        !isExternalQuestionnaireRoute &&
        !isEnabled &&
        !isExternalPdfRoute &&
        !isCompletedRoute &&
        !isPdfFormSubmissionRoute
      "
    />
    <ClientPortalBase v-else />
  </div>
</template>
